<template>
  <div class="main-header" :class="cssType" :style="kvStyle">
    <div class="kv">
      <img class="kv-logo" :class="locale" :src="logoImg" alt="Mini World Royale" />
      <template v-if="isMobile">
        <img v-if="mobileTitleImg" class="kv-title" :class="locale" :src="mobileTitleImg" :alt="$t('novShopping.kvText')" />
      </template>
    </div>

    <div v-if="isMobile" class="countdown-wrap">
      <ActCountDown
        class="countdown"
        :server-ms="props.serverMs"
        :start-ms="props.startMs"
        :end-ms="props.endMs"
      />
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import kvImg from '../../assets/imgs/mainHeader/kv/index.js'
import mobileTitleImg from '../../assets/imgs/mobile/mainHeader/mainTitle'
import defaultLogoImg from '@/assets/imgs/logo.png'
import hkLogoImg from '@/assets/imgs/logo-hk.png'
import viLogoImg from '@/assets/imgs/logo-vi.png'
import ActCountDown from '../ActCountDown/index.vue'

const cssType = isMobile ? 'mobile' : 'pc'
const { locale } = useI18n()

// 与公共页头保持一致：港澳台、越南使用地区 logo，其余地区使用通用版。
const logoImg = computed(() => {
  if (locale.value === 'vi') return viLogoImg
  if (['hk', 'tw'].includes(locale.value)) return hkLogoImg
  return defaultLogoImg
})

// PC 使用五语整图，移动端背景与五语标题分开适配。
const kvStyle = computed(() => (isMobile ? null : { backgroundImage: `url(${kvImg.value})` }))

const props = defineProps({
  serverMs: {
    type: Number,
    default: 0,
  },
  startMs: {
    type: Number,
    default: 0,
  },
  endMs: {
    type: Number,
    default: 0,
  },
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
